<script>
import toastr from 'toastr';

toastr.options = {
  closeButton: true,
  debug: false,
  newestOnTop: true,
  progressBar: false,
  positionClass: 'toast-top-center',
  extendedTimeOut: 0,
  timeOut: 3000,
  showDuration: '300',
  hideDuration: '300',
  showEasing: 'swing',
  hideEasing: 'linear',
};

export default toastr;
</script>

<style lang="sass">
@import @assets/stylesheets/clinic/clinic-variables.sass
@import @assets/stylesheets/clinic/toastr.min.css

#toast-container
  .toast
    display: flex
    justify-content: center
    align-items: center
    width: 65% !important
    max-width: 65% !important
    min-height: 70px
    padding-right: 30px
    margin-top: 20px
    margin-bottom: 0px
    background-image: none !important
    opacity: 0.9
    a
      .underline
        text-decoration: underline
      &:hover
        color: $color-reversal-font
        .underline
          text-decoration: none

    .toast-close-button
      position: absolute
      height: 16px
      right: 10px
      top: auto
      bottom: auto
      margin-bottom: 8px
      outline: none
      font-family: $regular-font-family

    .toast-message
      vertical-align: middle
      display: contents

    &::before
      font-family: 'Font Awesome 5 Free'
      position: relative
      content: '\f06a'
      font-weight: bold
      font-size: 16px
      line-height: 16px
      float: left
      color: $color-reversal-font
      left: -10px

    &.toast-error
      background-color: map-get($alert-themes, 'error')
      &::before
        content: '\f06a'

    &.toast-success
      background-color: map-get($alert-themes, 'success')
      &::before
        content: '\f00c'

    &.toast-warning
      background-color: map-get($alert-themes, 'warning')
      &::before
        content: '\f071'
</style>
